import './login.scss'
import { LoginBox } from 'components'
import { Link, Redirect, useLocation } from 'react-router-dom'
import { routeService, stringService } from 'services'
import { IonCol, IonGrid, IonLoading, IonRow } from '@ionic/react'
import { useCallback, useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useLogin, usePageTitle } from 'hooks'
import { authContext } from 'contexts/'
import BasePage from 'pages/base-page/base-page.page'

const Login: React.FC = () => {
  const auth = useContext(authContext)
  const [username, setUsername] = useState<string>()
  const [password, setPassword] = useState<string>()
  const [error, setError] = useState<string>()
  const [submitted, setSubmitted] = useState<boolean>(false)
  const [previousUrl, setPreviousUrl] = useState<string>()
  const { state } = useLocation<{ from?: string }>()

  const { t } = useTranslation()

  const titlePage = stringService.capitalizeFirstLetter(t('login'))
  usePageTitle(titlePage!)

  useEffect(() => {
    if (state?.from && state?.from !== routeService.generateRoutePath('/login')) {
      setPreviousUrl(state?.from)
    }
  }, [state])

  const clear = useCallback(
    (error_?: string) => {
      setSubmitted(false)
      if (error_) setError(t(error_))
      setUsername(undefined)
      setPassword(undefined)
    },
    [t],
  )

  useLogin(clear, username, password)

  const onLoginSubmit = (username: string, password: string) => {
    setError(undefined)
    setSubmitted(true)
    setUsername(username)
    setPassword(password)
  }

  const isAlreadyAuth = !!auth?.user

  if (isAlreadyAuth) {
    const redirect_to = previousUrl || routeService.generateRoutePath('/')
    return <Redirect to={redirect_to} />
  }

  const changeTokenSet = !!auth?.changeToken
  if (changeTokenSet) {
    return <Redirect to={routeService.generateRoutePath('/update-pw')} />
  }

  return (
    <BasePage pageClass="edisu-page-login" bgColor="#EDF2F5">
      <IonLoading isOpen={submitted} message={t('loading')} />
      <IonGrid className="edisu-login-grid">
        <IonRow className="ion-justify-content-center">
          <IonCol size="11" sizeLg="5">
            <h2 className="login-header">{t('login')}</h2>
            <p className="edisu-text-1">
              <b>{t('login_text_1')}</b>
            </p>
            <p className="edisu-text-1">{t('login_text_2')}</p>
            <p className="edisu-text-1">
              {t('missing_registration') + ' '}
              <Link to={routeService.generateRoutePath('/registration')}>{t('register')}</Link>
            </p>

            <p className="edisu-text-2">{t('spid_explanation')}</p>

            <LoginBox onLoginSubmit={onLoginSubmit} genericError={error} submitted={submitted} />
          </IonCol>
        </IonRow>
      </IonGrid>
    </BasePage>
  )
}

export default Login
